import React from "react";
import HomeImagesSection from "./Home/HomeImagesSection";
import NewsPreview from "./Home/NewsPreview";
import BlogPreview from "./Home/BlogPreview";
import BusinessAnalysis from "./Home/BusinessAnalysis";
import References from "./Home/References";
import ConsultingFields from "./Home/ConsultingFields";
import Ebook from "./Home/Ebook";
import { Helmet, HelmetProvider } from "react-helmet-async";
import OrgaCheckHome from "./Home/OrgaCheckHome";
import LinkedInWidget from "./Home/LinkedInWidget";
export default function Home() {
	return (
		<div>
			<HelmetProvider>
				<Helmet>
					<title>Feingeist Unternehmensberatung</title>
					<meta name="description" content="Feingeist" />
					<meta
						name="keywords"
						content="Feingeist , Unternehmensberatung , Immobilienwirtschaft  , Digitalisierungs , Prozessberatung , Unternehmenskäufe , Nachfolgelösung , Strategische , ESG"
					/>
				</Helmet>
			</HelmetProvider>
			<HomeImagesSection />

			<ConsultingFields />
			<hr />
			<NewsPreview />
			<hr />
			<References />
			<hr />
			<Ebook />

			<OrgaCheckHome />

			<BlogPreview />
			<LinkedInWidget />
			<BusinessAnalysis />
		</div>
	);
}
